import { render, staticRenderFns } from "./AddIncomeFromHistory.vue?vue&type=template&id=016ce5d8&scoped=true"
import script from "./AddIncomeFromHistory.vue?vue&type=script&lang=js"
export * from "./AddIncomeFromHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016ce5d8",
  null
  
)

export default component.exports